export default "__VITE_ASSET__8c9c6617__"